import React, { useState } from 'react';
import logo from "../images/logo2.png";
import '../style/navbar.css'
import ResumePopup from '../components/resume'; 

const Navbar = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handlePopupToggle = () => {
    setShowPopup(!showPopup);
  };
  return (
    <>
      <div className="main">
        <nav>
          <div
            className="logo"
            data-aos="fade-down-right"
            data-aos-duration="600"
          >
            <img src={logo} alt="" />
          </div>
          <div
            className="links"
            data-aos="fade-down-left"
            data-aos-duration="600"
          >
            <button className="button-53" onClick={handlePopupToggle}>Resume</button>
          </div>
        </nav>
        <ResumePopup showPopup={showPopup} handlePopupToggle={handlePopupToggle} />
      </div>
    </>
  );
};

export default Navbar;
